var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A5C73",
    fillRule: "evenodd",
    d: "M10.375.33c.075-.199.265-.33.477-.33.212 0 .402.131.477.33l2.579 7.302h7.284c.213 0 .404.133.477.333.074.2.016.424-.146.563l-6.087 5.039 2.548 7.642c.07.21-.005.441-.184.572-.179.13-.422.13-.6-.001l-6.349-4.652L4.5 21.78c-.18.128-.42.127-.598-.003s-.252-.359-.184-.568l2.548-7.642-6.088-5.04c-.162-.138-.22-.363-.146-.562.073-.2.264-.333.478-.333h7.284L10.375.33z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileStar);
export default __webpack_public_path__ + "static/media/profile-star.c5f93a86671b07f5748c3670b8298a3f.svg";
export { ForwardRef as ReactComponent };